import Component from './CreateOfferRequest'

export default Component
